export const ASSESSMENT_KEY = 'סוג משימה'
export const ASSESSMENT_VALUE = 'הערכה'
export const ASSESSMENT_KEY_ARB = 'סוג תוכן'
export const ASSESSMENT_VALUE_ARB = 'הערכה'

export const TYPELESSON_ASSESSMENT = 'RAMOT_ENV_EVALUATION_TASK'
export const TYPELESSON_AI_ASSESSMENT = 'RAMOT_ENV_AI_EVALUATION_TASK'

export const OPEN_CONTENT_CLASSIFICATIONS = [
  'תוכן פתוח',
  'مُحْتَوى مَفْتُوح'
]
